import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import BaseHomePage from "../pages/BasePage";
import { Box, Grid, Typography, Link, Button } from "@mui/material";
import event from "../resources/event.json";
import CountdownComponent from "../components/CountdownComponent";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import { getPastVideos, eventEnded } from "../helpers/EventHelper";

export default function MainPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    currentVideo: String(),
    nextVideo: String(),
  });

  const renderSeeYouSoon = () => {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          m: 3,
        }}
      >
        <Typography variant="h2">{`Videos disponibles`}</Typography>
        <Grid container spacing={2}>
          {getAllVideos()}
        </Grid>
      </Box>
    );
  };
  const renderCountdown = (splitStart, splitEnd) => {
    return (
      <Box sx={{}}>
        <h1 id="lessLabel">FALTAN</h1>
        <CountdownComponent date={event.startAt} />
        {
          <Link
            sx={{
              fontSize: 42,
              fontWeight: "bold",
              backgroundColor: "#FEFF02",
              borderRadius: 10,
              margin: 3,
              display: "none",
            }}
            href={
              "https://www.culebro.tv/registro-divergentes-20241717889459203"
            }
            target="_blank"
          >
            {"REGISTRATE"}
          </Link>
          /*
        <Box sx={{ m: "auto" }}>
          <Typography variant="h6">{"Agregalo a tu calendario"}</Typography>
          <AddToCalendarButton
            name="addToCal"
            label="Agrega a tu calendario"
            options={[
              "Apple",
              "Google",
              "iCal",
              "Microsoft365",
              "MicrosoftTeams",
              "Outlook.com",
              "Yahoo",
            ]}
            icsFile="https://firebasestorage.googleapis.com/v0/b/culebroapp.appspot.com/o/event.ics?alt=media&token=e5209487-ffe6-4a6d-80de-60fc19a6c4d5"
            timeZone="America/Mexico_City"
            startDate={event.startAt.split("T")[0]}
            endDate={event.endAt.split("T")[0]}
            startTime={`${splitStart[0]}:${splitStart[1]}`}
            endTime={`${splitEnd[0]}:${splitEnd[1]}`}
            buttonsList
            hideTextLabelButton
            bypassWebViewCheck
            buttonStyle="round"
          />
        </Box> */
        }
      </Box>
    );
  };

  const renderNextCountdown = () => {
    let view = null;
    console.log(data.nextVideo);
    if (data.nextVideo !== String()) {
      view = (
        <Box sx={{ m: "auto" }}>
          <Typography variant="h3">{"Proxima sesión"}</Typography>
          <CountdownComponent date={data.nextVideo} />
        </Box>
      );
    }

    if (data.currentVideo !== String()) {
      view = (
        <Box sx={{ m: "auto" }}>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("live", {
                state: {
                  video: data.currentVideo,
                  isAdmin: searchParams.get("type") === "9777979797",
                },
              });
            }}
            sx={{
              fontSize: 42,
              borderColor: "red",
              color: "black",
              borderWidth: 3,
              m: 3,
              textDecoration: "underline",
            }}
            endIcon={<Brightness1Icon sx={{ color: "red" }} />}
          >
            {"Ver en vivo"}
          </Button>
        </Box>
      );
    }

    return view;
  };

  const renderView = () => {
    let view = null;

    if (new Date() >= new Date(event.endAt)) {
      view = renderSeeYouSoon();
      console.log("1");
    } else if (new Date() >= new Date(event.startAt)) {
      console.log("2");
      let videos = getAllVideos();
      let topText = null;
      if (videos.length > Number()) {
        topText = (
          <Box>
            <Typography variant="h5">{"VIDEOS ANTERIORES"}</Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold" }}
            >{`DISPONIBLES EL ${new Date(
              event.endAt
            ).toLocaleString()}`}</Typography>
          </Box>
        );
      }
      view = (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            m: 3,
          }}
        >
          {renderNextCountdown()}
          {topText}
          <Grid container spacing={2}>
            {getAllVideos()}
          </Grid>
        </Box>
      );
      //  else {
      //   navigate("live", {
      //     state: { video: event.days[0].videos[0] },
      //   });
      // }
    } else {
      console.log("3");
      let splitStart = event.startAt.split("T")[1].split(":");
      let splitEnd = event.endAt.split("T")[1].split(":");
      view = renderCountdown(splitStart, splitEnd);
    }
    return view;
  };

  const playVideo = (video) => {
    if (eventEnded()) {
      navigate("/player", { state: video });
    }
  };

  const getAllVideos = () => {
    let aux = [];
    event.days.forEach((day) => {
      day.videos.forEach((video) => {
        if (new Date() > new Date(video.endAt)) {
          aux.push(
            <Grid key={video.link} item xs={12}>
              <Box
                component={"img"}
                src={`https://img.youtube.com/vi/${video.link}/0.jpg`}
                sx={{
                  cursor: "pointer",
                  width: { sx: "50vw", sm: "25vw" },
                  opacity: eventEnded() ? 1 : 0.5,
                }}
                onClick={() => {
                  playVideo(video);
                }}
              />
              <Typography variant="body">{`Fecha: ${new Date(
                video.startAt
              ).toLocaleDateString()}`}</Typography>
              {eventEnded() && (
                <Button
                  onClick={() => {
                    playVideo(video);
                  }}
                >{`Ver video`}</Button>
              )}
            </Grid>
          );
        }
      });
    });
    return aux;
  };

  const checkVideos = useCallback(() => {
    let day = new Date().getDate() - new Date(event.startAt).getDate();
    let date = event.days[day];
    console.log(day);
    if (date === undefined) {
      return;
    }

    let videos = date.videos.filter(
      (video) => new Date(video.endAt).getTime() >= new Date().getTime()
    );

    if (videos !== undefined) {
      if (videos.length === Number()) {
        let next = String();
        try {
          next = event.days[day + 1].videos[0].startAt;
        } catch (error) {}
        setData({
          ...data,
          nextVideo: next,
          currentVideo: String(),
        });
        return;
      }

      if (new Date() > new Date(videos[0].startAt)) {
        setData({ ...data, nextVideo: String(), currentVideo: videos[0] });
        if (getPastVideos().length === Number()) {
          navigate(`/live`, {
            state: {
              video: videos[0],
              isAdmin: searchParams.get("type") === "9777979797",
            },
          });
        }
      } else {
        setData({
          ...data,
          nextVideo: videos[0].startAt,
          currentVideo: String(),
        });
      }
    } else {
      setData({
        ...data,
        nextVideo: String(),
        currentVideo: String(),
      });
    }
  }, [data, navigate, searchParams]);

  useEffect(() => {
    let timer = null;

    if (localStorage.getItem("needRegister") === "true") {
      navigate("/registro");
    }

    timer = setInterval(() => {
      checkVideos();
    }, 1000);
    return () => clearInterval(timer);
  }, [checkVideos, navigate]);

  return <BaseHomePage>{renderView()}</BaseHomePage>;
}
